module.exports = __webpack_public_path__ + "static/media/radiant-chic.2c19c91a.png";